import React from "react";
import { Button, Modal } from "react-bootstrap";
import { ModalTermoUsoProps } from "../../interfaces";
import { HandThumbsDownFill, HandThumbsUpFill } from "react-bootstrap-icons";

export const TermoUsoModal: React.FC<ModalTermoUsoProps> = ({ show, onHide, aceite, handleAceite }) => {

    return (
        <Modal show={show} onHide={() => { onHide(); }} size="lg" centered backdrop='static'>
            <Modal.Header closeButton>
                <Modal.Title className="h6">Termo de uso</Modal.Title>
            </Modal.Header>

            <Modal.Body >
                <div className="ms-3 overflow-auto" style={{ maxHeight: '200px' }} >
                <h2 className="text-xl font-bold mb-4">Termos de Uso</h2>
                    <p>
                        Estes Termos de Uso regulam o uso do software MDF-e Web...
                    </p>

                    <p >
                        <strong>
                            1. Objeto
                        </strong>

                    </p>
                    <p className="mb-2" >

                        O MDF-e Web é um software como serviço (SaaS) que oferece emite MDF-e, efetua o encerramento, cancelamento, inclusão de condutor, inclusão de NF-e posteriomente e emite DAMDF-e.
                    </p>
                    <p className="lh-1">
                        O acesso é concedido mediante assinatura e aceitação destes Termos.
                    </p>
                    <p>
                        <strong>
                            2. Cadastro e Conta
                        </strong>
                        <li>
                            Para utilizar o serviço, o Usuário deve fornecer informações verdadeiras, completas e atualizadas.
                        </li>
                        <li>
                            O login e senha são pessoais e intransferíveis.
                        </li>
                        <li>
                            O Usuário é responsável pela segurança de suas credenciais e por todas as ações realizadas em sua conta.
                        </li>
                    </p>

                    <p>
                        <strong>
                            3. Licença de Uso
                        </strong>
                        <li >
                            É concedida ao Usuário uma licença limitada, não exclusiva e intransferível para utilizar o software.
                        </li>
                        <li >
                            É vedado copiar, modificar, distribuir, vender, alugar ou criar obras derivadas do software sem autorização expressa.
                        </li>

                    </p>

                    <p>
                        <strong>
                            4. Planos, Pagamentos e Cancelamento
                        </strong>
                        <li>
                            Os valores, periodicidade e formas de pagamento estarão disponíveis na página de contratação.
                        </li>
                        <li>
                            Direito de arrependimento: Compras realizadas fora de estabelecimento físico (ex.: pela internet) poderão ser canceladas em até 7 dias corridos após a contratação, conforme Art. 49 do CDC.
                        </li>
                        <li>
                            Cancelamentos após esse prazo não geram reembolso proporcional, salvo disposição expressa em contrato.
                        </li>
                        <li>
                            O não pagamento implica suspensão ou cancelamento do acesso.
                        </li>
                    </p>

                    <p>
                        <strong>
                            5. Responsabilidades do Usuário
                        </strong>

                        <li>
                            Utilizar o software apenas para fins lícitos e autorizados.
                        </li>

                        <li>
                            Não utilizar o serviço para armazenar ou transmitir conteúdo ilícito, difamatório, ofensivo ou que infrinja direitos de terceiros.
                        </li>
                        <li>
                            Não realizar engenharia reversa, invasão ou exploração de vulnerabilidades.
                        </li>
                    </p>

                    <p>
                        <strong>
                            6. Disponibilidade e Suporte
                        </strong>
                        <li>
                            O Fornecedor envidará esforços para manter o serviço disponível, podendo realizar manutenções programadas ou emergenciais.
                        </li>
                        <li>
                            O suporte será prestado por [e-mail/canal de atendimento] em [horário comercial].
                        </li>
                    </p>

                    <p>
                        <strong>
                            7. Proteção de Dados e LGPD
                        </strong>
                        <li>
                            O Fornecedor coleta e trata dados pessoais conforme a Lei Geral de Proteção de Dados (Lei nº 13.709/2018).
                        </li>
                        <li>
                            Os dados coletados incluem: nome, e-mail, dados de pagamento e demais informações fornecidas voluntariamente pelo Usuário.
                        </li>
                        <li>
                            A finalidade do tratamento é possibilitar o uso do serviço, comunicação e obrigações legais.
                        </li>
                        <li>
                            O Usuário poderá solicitar acesso, correção ou exclusão de seus dados pessoais a qualquer momento, conforme previsto na Política de Privacidade.
                        </li>
                        <li>
                            O Fornecedor não vende, aluga ou compartilha dados pessoais com terceiros, salvo quando necessário para execução do serviço ou cumprimento de obrigações legais.
                        </li>
                    </p>

                    <p>
                        <strong>
                            8. Limitação de Responsabilidade
                        </strong>
                        <li>
                            O Fornecedor não se responsabiliza por perdas indiretas, lucros cessantes ou perda de dados ocasionados pelo uso ou indisponibilidade do serviço.
                        </li>
                        <li>
                            O Usuário é responsável por manter cópias de segurança dos dados inseridos no sistema.
                        </li>
                    </p>
                    <p>
                        <strong>
                            9. Propriedade Intelectual
                        </strong>
                        <li>
                            Todo o conteúdo, código, marca e design do software são de propriedade exclusiva do Fornecedor.
                        </li>
                        <li>
                            O uso do software não implica transferência de propriedade intelectual.
                        </li>
                    </p>
                    <p>
                        <strong>
                            10. Alterações dos Termos
                        </strong>
                        <li>
                            O Fornecedor poderá alterar estes Termos a qualquer momento, notificando o Usuário com antecedência mínima de 7 dias.
                        </li>
                        <li>
                            O uso contínuo do serviço após alterações implica aceitação das novas condições.
                        </li>
                    </p>

                    <p>
                        <strong>
                            11. Foro
                        </strong>
                        <li>
                            Fica eleito o foro da comarca de Natal/RN, com renúncia de qualquer outro, para dirimir questões oriundas deste Termo.
                        </li>
                    </p>
                    <p>
                        <p>
                            <strong>
                                Declaração de Aceite
                            </strong>
                        </p>
                        <p>
                            Ao marcar a opção “Li e aceito os Termos de Uso” e utilizar o software, o Usuário concorda integralmente com as condições acima.
                        </p>
                    </p>
                </div>



            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" onClick={handleAceite}>
                    <HandThumbsUpFill className="me-1" />Li e aceito os Termos de Uso
                </Button>

                <Button variant="danger" onClick={() => { onHide(); }}>
                    <HandThumbsDownFill className="me-1" />Recusar
                </Button>
            </Modal.Footer>
        </Modal>

    )
}